import type { FC } from "react";

import { Card, type CardProps, CardRowSimple, LoadingSpinner } from "widgets";
import { useVisuallyLoading } from "widgets/hooks";

import { useError } from "@/app-utils/graphql/useError.js";
import { type GetFileEventsQuery, useGetFileEventsQuery } from "@/modules/files/graphql/files-queries.gql.js";
import { ContentPlaceholder } from "@/ui-modules/core/ContentPlaceholder.tsx";
import { PlaybookEventTile } from "@/ui-modules/core/tiles";

interface FileEventCardProps extends CardProps {
  fileId: number;
}

const responseContainsData = (data: GetFileEventsQuery) => {
  return data?.projectFileById?.eventResources?.length;
};

export const FileEventsCard: FC<FileEventCardProps> = (props) => {
  const { data, loading, error } = useGetFileEventsQuery({ variables: { fileId: props.fileId } });
  void useError(error);

  const file = data?.projectFileById;
  const fakeLoading = useVisuallyLoading(loading, 300);

  return (
    <Card {...props} style={{ minHeight: 100, ...props.style }}>
      {fakeLoading ? (
        <LoadingSpinner />
      ) : !responseContainsData(data) ? (
        <ContentPlaceholder>No related Playbook events available</ContentPlaceholder>
      ) : (
        file?.eventResources && (
          <>
            {file.eventResources.length > 0 && (
              <CardRowSimple label={"Related Playbook events"} maxWidth={580}>
                {file.eventResources?.map((playbookEvent) => (
                  <PlaybookEventTile event={playbookEvent.playbookEvent} key={playbookEvent.playbookEvent.id} />
                ))}
              </CardRowSimple>
            )}
          </>
        )
      )}
    </Card>
  );
};
